export default __webpack_public_path__ + "static/media/question2.b319ee2a.svg";